import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { Utils } from 'src/app/core/resources/utils';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { FreightListService } from '../cargo-list/cargo-list.service';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { MassiveCargoOperationComponent } from '../massive-cargo-operation/massive-cargo-operation.component';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';
import { CargoClassifierService } from 'src/app/core/services/cargo-classifier.service';
import { refreshCargoMassivePayments } from '../list-massive-payments-loads/list-massive-payments-loads.component';
@Component({
  selector: 'app-massive-payments',
  templateUrl: './massive-payments.component.html',
  styleUrls: ['./massive-payments.component.scss']
})
export class MassivePaymentsComponent implements OnInit {
  permission = Permission;
  massivePaymentsInput: FormControl = new FormControl('', Validators.required);
  massivePaymentsList: Array<string> = [];
  pageKey: number = 1;
  pageSize: number = 25;
  massiveAvailableLoadsListShow: Cargo[] = [];
  massiveUnavaliableLoadsListShow: (Cargo & { errorMessage?: string })[] = [];
  massiveNonExistentLoadsListShow: number[] = [];
  loadsSelectedList: Cargo[] = [];
  activeTab: number = 0;
  typeList: string = sessionStorage.getItem('_activeTab');
  constructor(
    public dialogRef: MatDialogRef<MassivePaymentsComponent>,
    public utils: Utils,
    public snackbarService: SnackBarService,
    public toPayService: FreightListService,
    public spinner: NgxSpinnerService,
    private dialog: MatDialog,
    public permissionRole: PermissionRole,
    private cargoClassifierService: CargoClassifierService,
    @Inject(MAT_DIALOG_DATA)
    public paramsDialog: {
      filters?: string
    }
  ) { }

  ngOnInit() {
    if (this.paramsDialog && this.paramsDialog.filters) this.openModalMassiveCargoOperation();
  }

  private async openModalMassiveCargoOperation() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: "Pagar servicios masivamente",
      subtitle: "Ingrese los consecutivos de los servicios que desea pagar separados por una coma.",
      label: "Servicios a pagar",
      confirmButton: "Siguiente",
      method: this.getListCargoToPayWrapper.bind(this),
      filters: this.paramsDialog.filters,
      receiveAsList: true,
      validationToCheckValid: (cargo: Cargo) => this.checkValidationService(cargo)
    }
    let result: {
      availableList: Cargo[],
      unavailableList: (Cargo & { errorMessage?: string })[],
      nonExistentList: number[],
      consecutiveList: string[]
    } = await this.dialog.open(MassiveCargoOperationComponent, dialogConfig).afterClosed().toPromise();
    if (!result) {
      this.dialogRef.close();
      return;
    };
    this.massivePaymentsList = result.consecutiveList;
    this.massiveNonExistentLoadsListShow = result.nonExistentList;
    this.massiveAvailableLoadsListShow = result.availableList;
    this.massiveUnavaliableLoadsListShow = result.unavailableList;
  }

  async refreshCargo($event: refreshCargoMassivePayments) {
    let cargoList = $event.typeLoads === 'available' ? this.massiveAvailableLoadsListShow : this.massiveUnavaliableLoadsListShow;
    let currentList = [...cargoList];
    let messageSnackbar = `El servicio No.${$event.cargo.consecutive} se ha actualizado al listado de servicios ${$event.typeLoads === 'available' ? `inhabilitados` : $event.typeLoads === 'unavailable' ? 'habilitados' : 'inexistentes'}`
    if ($event.action === 'delete') {
      currentList.splice($event.index, 1);
      this.snackbarService.openSnackBar(`${messageSnackbar}${$event && $event.reason ? ` por la siguiente razón: ${$event.reason}` : ''}`, undefined, 'info')
      this.massiveNonExistentLoadsListShow.push($event.cargo.consecutive);
    }
    else {
      const { isEnabled, isSelectable, errorMessage } = this.toPayService.checkValidationService($event.cargo, this.typeList, this.paramsDialog.filters)
      if (isEnabled && isSelectable && !errorMessage) {
        if ($event.typeLoads === 'available') currentList[$event.index] = $event.cargo;
        else {
          currentList.splice($event.index, 1);
          this.snackbarService.openSnackBar(messageSnackbar, undefined, 'info')
          this.massiveAvailableLoadsListShow.push($event.cargo);
        }
      }
      else {
        if ($event.typeLoads === 'unavailable') currentList[$event.index] = $event.cargo;
        else {
          currentList.splice($event.index, 1);
          this.snackbarService.openSnackBar(`${messageSnackbar}${errorMessage ? ` por la siguiente razón: ${errorMessage}` : ''}`, undefined, 'info')
          this.massiveUnavaliableLoadsListShow.push($event.cargo);
        }
      }
    }
    if ($event.typeLoads === 'available') this.massiveAvailableLoadsListShow = currentList
    else this.massiveUnavaliableLoadsListShow = currentList;
  }



  onSelectTab($event: number) {
    this.activeTab = $event;
  }

  //GETTERS
  getLoadLabel(label: string, numberOfLoads: number) {
    return `${label} (${numberOfLoads})`;
  }

  checkValidationService(cargo: Cargo): { isSelectable: boolean, isEnabled: boolean, errorMessage: string } {
    return this.toPayService.checkValidationService(cargo, this.typeList, this.paramsDialog.filters);
  }

  getListCargoToPayWrapper(paramsFilter: string, pageKey?: number, pageSize?: number) {
    return this.toPayService.getListCargoToPay(paramsFilter, pageKey, pageSize);
  }

  getNonExistentLoadsList(list: number[]) {
    return list.join(', ');
  }

  loadsSelected($event: Cargo[]) {
    this.loadsSelectedList = [];
    this.loadsSelectedList = $event;
  }

  payMassivePayments() {
    this.dialogRef.close(this.loadsSelectedList);
  }


}
